var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vue-autosuggest", {
    key: _vm.key,
    attrs: {
      "input-props": {
        id: _vm.refId,
        placeholder: _vm.refPlaceholder,
        class: [_vm.refClass, _vm.refBindClass],
        disabled: _vm.disabled,
      },
      suggestions: _vm.filteredOptions,
    },
    on: { selected: _vm.onSelected, focus: _vm.onFocus },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ suggestion }) {
          return _c("div", {}, [
            _c("div", { class: _vm.refItemClass }, [
              _vm._v(_vm._s(suggestion.item[_vm.refSuggestionSelectName])),
            ]),
          ])
        },
      },
    ]),
    model: {
      value: _vm.query,
      callback: function ($$v) {
        _vm.query = $$v
      },
      expression: "query",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }